import { render, staticRenderFns } from "./groupsendphone.vue?vue&type=template&id=19656519&scoped=true"
import script from "./groupsendphone.vue?vue&type=script&lang=js"
export * from "./groupsendphone.vue?vue&type=script&lang=js"
import style0 from "./groupsendphone.vue?vue&type=style&index=0&id=19656519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19656519",
  null
  
)

export default component.exports